import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { getUserId } from "../services/authorize";
import { useLoading } from '../contexts/LoadingContext';
import { getSemesterOrder } from "../utils/teachingUtils";

// การ์ดคาบแนะแนว 1 รายการ สำหรับมุมมองมือถือ
const GuidanceCard = ({ row, formatTime }) => (
  <div className="border rounded p-3">
    <div className="d-flex align-items-center justify-content-between gap-2">
      <div className="fw-semibold">คาบ {row.period_order} · ม.{row.tb_class_c_id}/{row.r_no}</div>
      <span className="fs-xs text-muted">{formatTime(row.period_begin)} - {formatTime(row.period_end)}</span>
    </div>
    <div className="mt-2 pt-2 border-top fs-sm">
      <div>กิจกรรมแนะแนว · ภาคเรียนที่ {row.semester}</div>
    </div>
    <div className="mt-2 pt-2 border-top">
      {row.already_checked ? (
        <Link to={`/advisor/guidance-check/${row.guid_id}`} className="btn btn-outline-success btn-sm w-100">
          <i className="ri-checkbox-circle-line"> เช็คชื่อแล้ว</i>
        </Link>
      ) : (
        <Link to={`/advisor/guidance-check/${row.guid_id}`} className="btn btn-outline-info btn-sm w-100">
          <i className="ri-user-follow-line"> เช็คชื่อ (แนะแนว)</i>
        </Link>
      )}
    </div>
  </div>
)

// การ์ดคาบสอนแทน 1 รายการ สำหรับมุมมองมือถือ
const SubCard = ({ row, formatTime }) => (
  <div className="border rounded p-3">
    <div className="d-flex align-items-center justify-content-between gap-2">
      <div className="fw-semibold">คาบ {row.period_order} · ม.{row.tb_class_c_id}/{row.r_no}</div>
      <span className="fs-xs text-muted">{formatTime(row.period_begin)} - {formatTime(row.period_end)}</span>
    </div>
    <div className="mt-2 pt-2 border-top fs-sm">
      <div><span className="text-muted">วิชา:</span> {row.sub_subid} {row.sub_subname}</div>
      <div><span className="text-muted">ครูเจ้าของวิชา (ลา):</span> {row.absent_teacher_name}</div>
    </div>
    <div className="mt-2 pt-2 border-top">
      {row.already_checked ? (
        <Link to={`/teaching/check-attendance/${row.r_id}/${row.teach_id}`} state={{ periods: [row.period_id] }}
          className="btn btn-outline-success btn-sm w-100">
          <i className="ri-checkbox-circle-line"> เช็คชื่อแล้ว</i>
        </Link>
      ) : (
        <Link to={`/teaching/check-attendance/${row.r_id}/${row.teach_id}`} state={{ periods: [row.period_id] }}
          className="btn btn-outline-warning btn-sm w-100">
          <i className="ri-user-follow-line"> เช็คชื่อ (สอนแทน)</i>
        </Link>
      )}
    </div>
  </div>
)

// การ์ดคาบสอนตามตาราง สำหรับมุมมองมือถือ
const ScheduleCard = ({ group, formatTime }) => {
  const first = group[0];
  const last = group[group.length - 1];
  const periodText = group.length > 1 ? `${first.period_order} - ${last.period_order}` : `${first.period_order}`;
  const timeText = group.length > 1
    ? `${formatTime(first.period_begin)} - ${formatTime(last.period_end)}`
    : `${formatTime(first.period_begin)} - ${formatTime(first.period_end)}`;
  const alreadyChecked = group.every(g => g.already_checked);
  return (
    <div className="border rounded p-3">
      <div className="d-flex align-items-center justify-content-between gap-2">
        <div className="fw-semibold">คาบ {periodText} · ม.{first.tb_class_c_id}/{first.r_no}</div>
        <span className="fs-xs text-muted">{timeText}</span>
      </div>
      <div className="mt-2 pt-2 border-top fs-sm">
        <div><span className="text-muted">วิชา:</span> {first.sub_subid} {first.sub_subname}</div>
        <div><span className="text-muted">อาจารย์ที่ปรึกษา:</span> {first.advisor_name}</div>
      </div>
      <div className="mt-2 pt-2 border-top">
        {alreadyChecked ? (
          <Link to={`/teaching/check-attendance/${first.r_id}/${first.teach_id}`}
            state={{ periods: group.map(g => g.period_id) }}
            className="btn btn-outline-success btn-sm w-100">
            <i className="ri-checkbox-circle-line"> เช็คชื่อแล้ว</i>
          </Link>
        ) : (
          <Link to={`/teaching/check-attendance/${first.r_id}/${first.teach_id}`}
            state={{ periods: group.filter(g => !g.already_checked).map(g => g.period_id) }}
            className="btn btn-outline-primary btn-sm w-100">
            <i className="ri-user-follow-line"> เช็คชื่อ ม.{first.tb_class_c_id}/{first.r_no}</i>
          </Link>
        )}
      </div>
    </div>
  )
}

export default function Attendance() {
  const { setLoading } = useLoading();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const [data, setData] = useState([]);
  const [yearId, setYearId] = useState(null)
  const [selectedYear, setSelectedYear] = useState("");
  const [subData, setSubData] = useState([]); // คาบที่ได้รับมอบหมายให้สอนแทนวันนี้
  const [guidanceData, setGuidanceData] = useState([]); // คาบแนะแนววันนี้ (เฉพาะครูประจำชั้น)
  const [view, setView] = useState(() =>
    (typeof window !== 'undefined' && window.innerWidth < 768) ? 'card' : 'table')

  // โหลดคาบสอนแทนของวันนี้
  useEffect(() => {
    const today = new Date();
    const ymd = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    axiosInstance.get(`${process.env.REACT_APP_API}/getSubstitutionsOnDay/${getUserId()}/${ymd}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
      .then(res => setSubData(res.data || []))
      .catch(() => setSubData([]));
  }, []);

  // โหลดคาบแนะแนวของวันนี้ (ครูที่ไม่ได้เป็นครูประจำชั้นจะได้ [] เฉย ๆ)
  useEffect(() => {
    if (yearId === null) return;
    axiosInstance.get(`${process.env.REACT_APP_API}/getGuidanceOnDay/${getUserId()}/${yearId}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
      .then(res => setGuidanceData(res.data || []))
      .catch(() => setGuidanceData([]));
  }, [yearId]);

  useEffect(() => {
    setLoading(true);
    // get yearId from lastest year in database
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        const list = res.data;

        // ใช้ index 0 ได้เลย เพราะเรียงจากมากไปน้อยอยู่แล้ว
        const latest = list[0];
        setYearId(latest.year_id);
        setSelectedYear(`ปีการศึกษา ${latest.year_year}`);
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [setLoading])

  useEffect(() => {
    setLoading(true);
    if (yearId === null) return; // don't run if yearId isn't loaded yet
    
    axiosInstance.get(`${process.env.REACT_APP_API}/getSubjectTeachingOnDay/${getUserId()}/${yearId}`,
    {
      headers: {
          authorization: `Bearer ${getToken()}`
      }
    })
      .then(response => {
        setData(response.data)
        // ถ้า response.data เป็น null หรือ undefined จะใช้ [] แทน
        // setIsLoading(false)
        console.log(response.data)
      })
      .catch(err => {
        console.log(err)
        // 404 = ไม่มีคาบสอนตามตารางในวันนี้ ซึ่งเป็นเรื่องปกติ
        // (เช่น ครูที่ได้รับมอบหมายสอนแทนแต่ไม่มีคาบของตัวเอง) ไม่ต้องแจ้ง error
        if (err.response?.status === 404) {
          setData([])
          return
        }
        // แจ้งเฉพาะกรณีที่เป็นข้อผิดพลาดจริง ๆ
        Swal.fire({
          title: err.response?.data?.title || err.response?.statusText || "เกิดข้อผิดพลาด",
          text: err.response?.data?.message || "ไม่สามารถโหลดข้อมูลได้",
          icon: "error"
        })
      })
      .finally(() => {
        setLoading(false);
      })
  }, [yearId, setLoading])

  const formatTime = (time) => {
    if (!time) return '';
    return time.substring(0, 5);
  }

  // ฟังก์ชันดึงเลขตัวแรกจากช่วงคาบ เช่น "5-6" => 5, "4" => 4
  function getPeriodStart(periodDisplay) {
    if (typeof periodDisplay === 'number') return periodDisplay;
    if (typeof periodDisplay === 'string') return Number(periodDisplay.split('-')[0]);
    return 0;
  }

  // ฟังก์ชัน group คาบติดกันในห้องเดียวกัน
  function groupConsecutivePeriods(data) {
    // data ต้อง sort ตาม teach_id, r_id, period_order ก่อน
    const sorted = [...data].sort((a, b) => 
      a.teach_id - b.teach_id ||
      a.r_id - b.r_id ||
      getPeriodStart(a.period_order) - getPeriodStart(b.period_order)
    );
    const result = [];
    let group = [];

    for (let i = 0; i < sorted.length; i++) {
      const curr = sorted[i];
      const prev = sorted[i - 1];

      if (
        i === 0 ||
        curr.teach_id !== prev.teach_id ||
        curr.r_id !== prev.r_id ||
        curr.period_order !== prev.period_order + 1
      ) {
        if (group.length) result.push(group);
        group = [curr];
      } else {
        group.push(curr);
      }
    }
    if (group.length) result.push(group);
    return result;
  }

  // const safeData = Array.isArray(data) ? data : []; // ใช้เช็คว่า data เป็น array หรือไม่ แต่คอมเม้นไว้เพราะใช้ set [] ใน response แล้ว
  const grouped = groupConsecutivePeriods(data)

  // ถ้าตอนนี้อยู่เทอม 2 ให้แสดงภาคเรียนที่ 2 ก่อน
  const semesterOrder = getSemesterOrder();

  // render การ์ดของภาคเรียนหนึ่ง ๆ (มุมมองการ์ด)
  const renderSemesterCards = (sem) => (
    <Row className="g-3">
      {grouped && grouped.length > 0 && grouped.some(g => g[0].sub_semester === sem) ? (
        grouped.filter(g => g[0].sub_semester === sem)
          .sort((a, b) => a[0].period_order - b[0].period_order)
          .map((group) => (
            <Col key={group[0].teach_id + '-' + group[0].r_id + '-' + group[0].period_order} xs={12} md={6} xl={4}>
              <ScheduleCard group={group} formatTime={formatTime} />
            </Col>
          ))
      ) : (
        <Col xs={12}><div className="text-center py-3">ไม่พบข้อมูล</div></Col>
      )}
    </Row>
  );

  // render ส่วนตาราง (หัวตาราง + แถวข้อมูล) ของภาคเรียนหนึ่ง ๆ (มุมมองตาราง)
  const renderSemesterTableSection = (sem) => (
    <React.Fragment>
      <thead>
        <tr className="text-center">
          <th scope="row" colSpan={7}>ภาคเรียนที่ {sem}</th>
        </tr>
      </thead>
      <thead>
        <tr>
          <th scope="col" className="text-center" style={{ width: "60px" }}>คาบที่</th>
          <th scope="col" className="text-center" style={{ width: "100px" }}>เวลา</th>
          <th scope="col" className="text-center">วิชา</th>
          <th scope="col" className="text-center" style={{ width: "70px" }}>ชั้น</th>
          <th scope="col" className="text-center" style={{ width: "80px" }}>ภาคเรียนที่</th>
          <th scope="col" className="text-center">อาจารย์ที่ปรึกษา</th>
          <th scope="col" className="text-center" style={{ width: "120px" }}></th>
        </tr>
      </thead>
      <tbody>
        {grouped && grouped.length > 0 && grouped.some(g => g[0].sub_semester === sem) ? (
          grouped
            .filter(g => g[0].sub_semester === sem)
            .sort((a, b) => a[0].period_order - b[0].period_order)
            .map((group) => {
              const first = group[0];
              const last = group[group.length - 1];
              const periodText = group.length > 1
                ? `${first.period_order} - ${last.period_order}`
                : `${first.period_order}`;
              const timeText = group.length > 1
                ? `${formatTime(first.period_begin)} - ${formatTime(last.period_end)}`
                : `${formatTime(first.period_begin)} - ${formatTime(first.period_end)}`;
              const alreadyChecked = group.every(g => g.already_checked);
              return (
                <tr key={first.teach_id + '-' + first.r_id + '-' + first.period_order}>
                  <th scope="row" className="text-center">{periodText}</th>
                  <td className="text-center">{timeText}</td>
                  <td className="text-center">{first.sub_subid + " " + first.sub_subname}</td>
                  <td className="text-center">{first.tb_class_c_id + "/" + first.r_no}</td>
                  <td className="text-center">{first.sub_semester}</td>
                  <td className="text-center">{first.advisor_name}</td>
                  <td className="text-center">
                    {alreadyChecked ? (
                      <Link
                        to={`/teaching/check-attendance/${first.r_id}/${first.teach_id}`}
                        state={{ periods: group.map(g => g.period_id) }}
                        className="text-success"
                      >
                        <i className="ri-checkbox-circle-line"> เช็คชื่อแล้ว</i>
                      </Link>
                    ) : (
                      <Link
                        to={`/teaching/check-attendance/${first.r_id}/${first.teach_id}`}
                        state={{ periods: group.filter(g => !g.already_checked).map(g => g.period_id) }}
                      >
                        <i className="ri-user-follow-line"> เช็คชื่อ ม.{first.tb_class_c_id + "/" + first.r_no}</i>
                      </Link>
                    )}
                  </td>
                </tr>
              );
            })
        ) : (
          <tr>
            <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
          </tr>
        )}
      </tbody>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ข้อมูลการสอน</Link></li>
              <li className="breadcrumb-item active" aria-current="page">เช็คชื่อนักเรียน</li>
            </ol>
            <h4 className="main-title mb-0">เช็คชื่อนักเรียน</h4>
          </div>
          <div className="btn-group btn-group-sm mt-3 mt-md-0" role="group" aria-label="สลับมุมมอง">
            <button type="button" className={`btn btn${view === 'table' ? '' : '-outline'}-primary`}
              onClick={() => setView('table')} title="มุมมองตาราง">
              <i className="ri-table-line" />
            </button>
            <button type="button" className={`btn btn${view === 'card' ? '' : '-outline'}-primary`}
              onClick={() => setView('card')} title="มุมมองการ์ด">
              <i className="ri-layout-grid-line" />
            </button>
          </div>
        </div>

        {guidanceData && guidanceData.length > 0 && (
          <Row className="g-12 mb-4">
            <Col xl="12">
              <Card className="card-one border-info">
                <Card.Header>
                  <Card.Title as="h6" className="text-info">
                    <i className="ri-compass-3-line"></i> คาบแนะแนววันนี้ (ครูประจำชั้น)
                  </Card.Title>
                </Card.Header>
                <Card.Body className="p-3">
                  {view === 'card' ? (
                    <Row className="g-3">
                      {guidanceData
                        .sort((a, b) => a.period_order - b.period_order)
                        .map((row) => (
                          <Col key={`guidance-${row.guid_id}`} xs={12} md={6} xl={4}>
                            <GuidanceCard row={row} formatTime={formatTime} />
                          </Col>
                        ))}
                    </Row>
                  ) : (
                  <Table responsive hover className="mb-0">
                    <thead>
                      <tr>
                        <th className="text-center" style={{ width: "60px" }}>คาบที่</th>
                        <th className="text-center" style={{ width: "100px" }}>เวลา</th>
                        <th className="text-center">กิจกรรม</th>
                        <th className="text-center" style={{ width: "70px" }}>ชั้น</th>
                        <th className="text-center" style={{ width: "80px" }}>ภาคเรียนที่</th>
                        <th className="text-center" style={{ width: "180px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {guidanceData
                        .sort((a, b) => a.period_order - b.period_order)
                        .map((row) => (
                          <tr key={`guidance-${row.guid_id}`} className="text-center">
                            <th scope="row">{row.period_order}</th>
                            <td>{formatTime(row.period_begin)} - {formatTime(row.period_end)}</td>
                            <td>กิจกรรมแนะแนว</td>
                            <td>{row.tb_class_c_id + "/" + row.r_no}</td>
                            <td>{row.semester}</td>
                            <td>
                              {row.already_checked ? (
                                <Link to={`/advisor/guidance-check/${row.guid_id}`} className="text-success">
                                  <i className="ri-checkbox-circle-line"> เช็คชื่อแล้ว</i>
                                </Link>
                              ) : (
                                <Link to={`/advisor/guidance-check/${row.guid_id}`}>
                                  <i className="ri-user-follow-line"> เช็คชื่อ (แนะแนว)</i>
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        {subData && subData.length > 0 && (
          <Row className="g-12 mb-4">
            <Col xl="12">
              <Card className="card-one border-warning">
                <Card.Header>
                  <Card.Title as="h6" className="text-warning">
                    <i className="ri-user-shared-line"></i> คาบสอนแทนวันนี้
                  </Card.Title>
                </Card.Header>
                <Card.Body className="p-3">
                  {view === 'card' ? (
                    <Row className="g-3">
                      {subData
                        .sort((a, b) => a.period_order - b.period_order)
                        .map((row) => (
                          <Col key={`sub-${row.sub_id}`} xs={12} md={6} xl={4}>
                            <SubCard row={row} formatTime={formatTime} />
                          </Col>
                        ))}
                    </Row>
                  ) : (
                  <Table responsive hover className="mb-0">
                    <thead>
                      <tr>
                        <th className="text-center" style={{ width: "60px" }}>คาบที่</th>
                        <th className="text-center" style={{ width: "100px" }}>เวลา</th>
                        <th className="text-center">วิชา</th>
                        <th className="text-center" style={{ width: "70px" }}>ชั้น</th>
                        <th className="text-center">ครูเจ้าของวิชา (ลา)</th>
                        <th className="text-center" style={{ width: "160px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {subData
                        .sort((a, b) => a.period_order - b.period_order)
                        .map((row) => (
                          <tr key={`sub-${row.sub_id}`} className="text-center">
                            <th scope="row">{row.period_order}</th>
                            <td>{formatTime(row.period_begin)} - {formatTime(row.period_end)}</td>
                            <td>{row.sub_subid + " " + row.sub_subname}</td>
                            <td>{row.tb_class_c_id + "/" + row.r_no}</td>
                            <td>{row.absent_teacher_name}</td>
                            <td>
                              {row.already_checked ? (
                                <Link
                                  to={`/teaching/check-attendance/${row.r_id}/${row.teach_id}`}
                                  state={{ periods: [row.period_id] }}
                                  className="text-success"
                                >
                                  <i className="ri-checkbox-circle-line"> เช็คชื่อแล้ว</i>
                                </Link>
                              ) : (
                                <Link
                                  to={`/teaching/check-attendance/${row.r_id}/${row.teach_id}`}
                                  state={{ periods: [row.period_id] }}
                                >
                                  <i className="ri-user-follow-line"> เช็คชื่อ (สอนแทน)</i>
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6">{selectedYear}</Card.Title>
                {/* <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav> */}
              </Card.Header>
              <Card.Body className="p-3">
                {view === 'card' ? (
                  <>
                    {semesterOrder.map((sem, idx) => (
                      <div key={sem} className={idx < semesterOrder.length - 1 ? 'mb-4' : ''}>
                        <h6 className="text-center mb-3">ภาคเรียนที่ {sem}</h6>
                        {renderSemesterCards(sem)}
                      </div>
                    ))}
                  </>
                ) : (
                <Table responsive hover className="mb-0">
                  {semesterOrder.map((sem) => (
                    <React.Fragment key={sem}>
                      {renderSemesterTableSection(sem)}
                    </React.Fragment>
                  ))}
                </Table>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  )
}